<template>
  <div id="app" :class="classes">
    <wo-page>
      <app-header v-if="showHeader" :main-navigation="mainNavigation" />
      <router-view/>
    </wo-page>
    <div v-show="currentModal" class="po-modal-backdrop">
      <div v-if="currentModal" class="po-modal" :class="modalClasses">
        <component v-bind:is="currentModal" v-bind="currentProps"></component>
      </div>
    </div>
    <toast />
  </div>
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'
import { findRoot } from '@/router'

import { BrandEnum } from '@/model/environment'

import AppHeader from './AppHeader.vue'
import Toast from '@/components/general/Toast'

export default {
  components: { Toast, AppHeader },
  computed: mapState({
    currentModal: state => state.modal.component,
    env: state => state.environment.current,
    currentProps: state => state.modal.props,
    showHeader () {
      return !this.$route.meta || (this.$route.meta && !this.$route.meta.public && !this.$route.meta.focus)
    },
    mainNavigation () {
      const root = findRoot(this.$route)
      return root && root.meta && _.map(root.meta.mainRoutes, this.createTab)
    },
    modalClasses () {
      return {
        'po-modal__lg': this.currentProps.modLg
      }
    },
    classes () {
      return { 'theme-alt': this.env.id === BrandEnum.values.CHAMPION.id }
    }
  }),
  methods: {
    createTab (route) {
      return { route: route }
    }
  }
}
</script>
<style lang="scss">

$po-modal-backdrop-z-index: 1000;
$po-modal-z-index: $po-modal-backdrop-z-index + 1;
$po-modal-width: 600px;
$po-modal-width-lg: 800px;
$po-modal-padding: 15px;

#app {
  position: relative;
}

body.po-modal-open {
  overflow: hidden;
}

.po-modal-backdrop {
  position: fixed;
  display: flex;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;

  padding: $po-modal-padding;
  overflow: scroll;

  z-index: $po-modal-backdrop-z-index;

  background-color: rgba(0, 0, 0, .7);

  justify-content: center;
}

.po-modal {
  width: 100%;
  margin: $po-modal-padding * 4;
  z-index: $po-modal-z-index;

  @media screen and (min-width: $po-modal-width) {
    width: $po-modal-width;
  }

  &.po-modal__lg {
    @media screen and (min-width: $po-modal-width-lg) {
      width: $po-modal-width-lg;
    }
  }
}

</style>
